import '../../style/index.less';
import './index.less';
// style dependencies
import '../../tooltip/style';
import '../../input/style';



// WEBPACK FOOTER //
// ./components/typography/style/index.tsx